export default "__VITE_ASSET__CzSizuYA__"